import React from "react";
import styled, { keyframes } from "styled-components";
import { FaPaperPlane, FaSpinner } from "react-icons/fa";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: var(--chat-icon, #4a4a4a);
  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }
  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
  ${({ $phone }) => $phone && `
    width: 44px;
    height: 44px;
    margin-left: 0;
    border-radius: 999px;
    background: var(--action-bg);
    color: var(--action-text);
    justify-content: center;
    &:disabled {
      opacity: 1;
      background: transparent;
      color: var(--text-muted);
    }
    &:hover:not(:disabled) {
      background: var(--action-bg-hover);
      color: var(--action-text);
      transform: none;
    }
  `}
`;

const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const Spinning = styled(FaSpinner)`
  animation: ${spin} 0.8s linear infinite;
`;

const ButtonLabel = styled.span`
  margin-left: 5px;
`;

export default function ChatSendButton({
  sending,
  disabled,
  onClick,
  className,
  title = "Send",
  phone = false,
}) {
  return (
    <IconButton
      className={className}
      type="button"
      onClick={onClick}
      title={title}
      disabled={disabled}
      $phone={phone}
      aria-label={title}
    >
      <IconSlot>
        {sending ? <Spinning size={14} /> : <FaPaperPlane size={phone ? 16 : 14} />}
      </IconSlot>
      { !phone && <ButtonLabel>Submit</ButtonLabel> }
    </IconButton>
  );
}
